import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import SearchForm from "../../form/search/SearchForm";
import { GridList } from "@material-ui/core";
import { getVehicles, searchVehicles } from "../../api";
import { Layout, Row, Col, message, Modal, Spin, Pagination } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { Helmet } from "react-helmet";
import { REDIRECT_URL } from "../../api/EndPoints";
const { Content } = Layout;
const Loading = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Search = () => {
  const history = useHistory();
  const location = useLocation();
  const [vehicles, setVehicle] = useState([]);
  const [pagination, setPagination] = useState({
    per_page: 15,
    current_page: 1,
    from: 0,
    to: 0,
    total: 0,
    last_page: 0,
    path: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSearch = useCallback(
    (data) => {
      const params = {
        include: "branch,type,model,images,rate",
        duration: data?.duration,
        budget: data?.budget,
        model_group: data?.model,
        car_type: data?.type,
        seat: data?.seat,
        fuel_type: data?.fuel,
        make: data?.make,
        transmission: data?.transmission,
        year: data?.year,
        type: data?.type,
      };

      setLoading(true);
      searchVehicles({ token: "", params })
        .then((response) => {
          setLoading(false);
          if (response.data.length === 0) {
            Modal.info({
              title: "Not found",
              content: (
                <div>
                  <p>There is no vehicles in your choice.</p>
                </div>
              ),
              onOk: () => {
                history.replace();
                window.location.reload(false);
              },
            });
          } else {
            setPagination(response?.meta);
          }
          setVehicle(response.data);
        })
        .catch((error) => {});
    },
    [location.state]
  );

  const loadInitialVehicles = useCallback((page) => {
    setLoading(true);
    getVehicles({ token: undefined, page: page })
      .then((response) => {
        setLoading(false);
        setPagination(response?.meta);
        setVehicle(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error) {
          setLoading(false);
          if (error?.response.status) {
            message.error(
              "Uh-oh! It looks like we're experiencing high traffic right now. Please try again in a moment. Thanks for your understanding!"
            );
          }
        }
      });
  }, []);

  useEffect(() => {
    message.config({ top: 100 });
    setLoading(true);
    if (location.state) {
      handleSearch({
        make: location.state?.brand || location?.state?.make,
        model_group: location?.state?.model,
        type: location?.state?.type,
        seat: location?.state?.seat,
      });
    } else {
      loadInitialVehicles();
    }
  }, [location.state, handleSearch, loadInitialVehicles]);

  const handlePaginationChange = (page) => {
    loadInitialVehicles(page);
  };

  return (
    <Content test_id="search" className="searchContainer">
      <Helmet>
        <title>Vehicle: Yoma Fleet</title>
        <meta
          name="description"
          content="A Complete and cost effective vehicle management solution from procurement to delivery, maintenance, replacement and after sales service."
        />
        <meta property="url" content={`${REDIRECT_URL}/vehicle`} />

        <meta property="og:title" content="Vehicle: Yoma Fleet" />
        <meta property="og:site_name" content="Yomafleet" />
        <meta property="og:url" content={`${REDIRECT_URL}/vehicle`} />
        <meta
          property="og:description"
          content="A Complete and cost effective vehicle management solution from procurement to delivery, maintenance, replacement and after sales service."
        />
      </Helmet>
      <Row justify="center" className="search" style={{ height: "100%" }}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          xxl={{ span: 6 }}
          className="search-left"
        >
          <SearchForm
            onSearch={handleSearch}
            value={{ make: location.state?.brand }}
            showFilter
            defaultValues={location.state}
            loading={loading}
          />
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 18 }}
          xl={{ span: 18 }}
          xxl={{ span: 18 }}
          className="search-right"
        >
          <div className="paginationContainer">
            <h5>
              <span className="availableCar">
                {loading ? (
                  <Spin indicator={Loading} size="large" />
                ) : (
                  // vehicles.length
                  pagination?.total
                )}
              </span>
              Car(s) Available
            </h5>
            {pagination?.total >= 15 && (
              <Pagination
                pageSize={pagination?.per_page}
                current={pagination?.current_page}
                total={pagination?.total}
                onChange={handlePaginationChange}
                style={{ display: "inline", alignSelf: "right" }}
              />
            )}
          </div>

          <GridList cols={2} spacing={10}>
            {vehicles.map((vehicle, key) => {
              return (
                <div
                  test_id={`vehicle-${key}`}
                  className="search-result-cell"
                  key={vehicle.id}
                >
                  <div
                    className="searchResultContainer"
                    key={key}
                    onClick={() =>
                      history.push({
                        pathname: `/vehicles/${vehicle.id}`,
                        // state: { vehicle_id: vehicle.id },
                      })
                    }
                  >
                    <img
                      className="search-result-cell-preview"
                      src={vehicle.feature_photo}
                      alt={vehicle.name}
                    />
                    <div className="search-result-cell-info">
                      <span className="search-result-cell-info-name">
                        {vehicle.name} <br />
                        {vehicle.fuel_type} - {vehicle.transmission}
                      </span>

                      {/* <span className="search-result-cell-info-price">
                        <br />
                        {vehicle.fuel_type} - {vehicle.transmission}
                      </span> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </GridList>
          {pagination?.total >= 15 && (
            <Pagination
              pageSize={pagination?.per_page}
              current={pagination?.current_page}
              total={pagination?.total}
              onChange={handlePaginationChange}
              style={{ marginTop: 70, float: "right" }}
            />
          )}
        </Col>
        <div className="clearfix"></div>
      </Row>
    </Content>
  );
};

export default Search;
